import React from 'react';
import { Plug } from 'lucide-react';

const IntegrationsSection = () => {
  const integrations = [
    { name: 'PostgreSQL', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg' },
    { name: 'MySQL', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg' },
    { name: 'BigQuery', logo: 'https://cdn.simpleicons.org/googlebigquery/669DF6' },
    { name: 'Microsoft SQL Server', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg' },
    { name: 'Oracle', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/oracle/oracle-original.svg' },
    { name: 'Gmail', logo: 'https://cdn.simpleicons.org/gmail/EA4335' },
    { name: 'Google Drive', logo: 'https://cdn.simpleicons.org/googledrive/4285F4' },
    { name: 'Google Docs', logo: 'https://cdn.simpleicons.org/googledocs/4285F4' },
    { name: 'Google Sheets', logo: 'https://cdn.simpleicons.org/googlesheets/34A853' },
    { name: 'Google Slides', logo: 'https://cdn.simpleicons.org/googleslides/FBBC04' },
    { name: 'Slack', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/slack/slack-original.svg' },
    { name: 'Twilio', logo: 'https://cdn.simpleicons.org/twilio/F22F46' },
    { name: 'Notion', logo: 'https://cdn.simpleicons.org/notion/FFFFFF' }
  ];

  return (
    <section className="section-spacing bg-[var(--bg-primary)] overflow-hidden">
      <div className="light-full-container">
        <div className="light-content-container">
          {/* Section Header - matching Agent Builder style */}
          <div className="text-center space-y-6 mb-10">
            <div className="flex items-center justify-center gap-4">
              <div className="icon-container">
                <Plug className="w-8 h-8" />
              </div>
              <h3 className="heading-1">Integrations</h3>
            </div>
            <p className="body-large max-w-4xl mx-auto">
              Connect seamlessly with your existing tools and databases. OnePlace integrates with all your favorite platforms.
            </p>
          </div>

          {/* Infinite Carousel */}
          <div className="relative">
            <div className="carousel-container">
              <div className="carousel-track">
                {/* First set of logos */}
                {integrations.map((integration, index) => (
                  <div key={`first-${index}`} className="carousel-item">
                    <div className="integration-logo-wrapper">
                      <img
                        src={integration.logo}
                        alt={integration.name}
                        className="integration-logo"
                      />
                    </div>
                  </div>
                ))}
                {/* Duplicate set for seamless loop */}
                {integrations.map((integration, index) => (
                  <div key={`second-${index}`} className="carousel-item">
                    <div className="integration-logo-wrapper">
                      <img
                        src={integration.logo}
                        alt={integration.name}
                        className="integration-logo"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Horizontal Divider */}
          <div className="mt-8 border-t border-[var(--border-subtle)]"></div>
        </div>
      </div>

      <style jsx>{`
        .carousel-container {
          width: 100%;
          overflow: hidden;
          position: relative;
          padding: 1rem 0;
        }

        .carousel-track {
          display: flex;
          gap: 2.8rem;
          animation: scroll 42s linear infinite;
          width: fit-content;
          padding: 0.5rem 0;
        }

        .carousel-item {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.5rem;
        }

        .integration-logo-wrapper {
          width: 140px;
          height: 140px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 2rem;
          transition: all 0.3s ease;
          box-shadow: 
            inset 0 1px 0 rgba(255, 255, 255, 0.1),
            0 8px 24px rgba(0, 0, 0, 0.4);
          backdrop-filter: blur(10px);
        }

        .integration-logo-wrapper:hover {
          transform: translateY(-8px);
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.06) 100%);
          box-shadow: 
            0 0 30px rgba(0, 229, 255, 0.2),
            inset 0 1px 0 rgba(255, 255, 255, 0.15),
            0 12px 32px rgba(0, 0, 0, 0.5);
          border-color: rgba(0, 229, 255, 0.3);
        }

        .integration-logo {
          width: 100%;
          height: 100%;
          object-fit: contain;
          opacity: 0.85;
          transition: all 0.3s ease;
        }

        .integration-logo-wrapper:hover .integration-logo {
          opacity: 1;
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        /* Pause animation on hover */
        .carousel-container:hover .carousel-track {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default IntegrationsSection;
